import React from 'react';
import { Card, CardBody, Container } from 'reactstrap'
import {StaticImage} from "gatsby-plugin-image";
import {downloadAppStoreUrl} from '../../constants/layout';
import { BrowserView, MobileView } from "react-device-detect";

const appStoreIcon: string = require("../../assets/images/app-store-btn-mobile.svg").default;
const imageOneMobile: string = require("../../assets/images/image-one-mobile.png").default;
const imageTwoMobile: string = require("../../assets/images/image-two-mobile.png").default;

interface GetTheAppProps {
  isDealers?: boolean;
  altText: string;
}

const GetTheApp = ({ isDealers, altText }: GetTheAppProps) => {
  return (
    <section className="section py-5">
      <Container>
        <div className='mt-3'>
          <Card>
            <CardBody className='get-the-app-card d-flex py-0'>
              {/* Browser View Images */}
              <BrowserView>
              {isDealers ? <StaticImage className="get-the-app-image dealers" src={"../../assets/images/image-two.png"} alt={altText} /> :
                <StaticImage className="get-the-app-image" src={"../../assets/images/image-one.png"} alt={altText} />}
              </BrowserView>

              {/* Mobile View Images */}
              <MobileView>
              {isDealers ? <img className="get-the-app-image dealers" src={imageTwoMobile} alt={altText} /> :
                <img className="get-the-app-image" src={imageOneMobile} alt={altText} />}
              </MobileView>

              <div className='get-the-app'>
                <h1 className='get-the-app-title'>Start your first In-Store Order</h1>
                <h3 className='get-the-app-subtitle mb-4'>Get our App now!</h3>
                <div className='get-the-app-desktop d-flex align-items-center'>
                  <StaticImage src={"../../assets/images/qr-code-white.svg"} alt="qr-code"/>
                  <ol className="m-0">
                    <li>Scan the QR code</li>
                    <li>Download the Mavsign app</li>
                    <li>Login using your dealer credentials</li>
                  </ol>
                </div>
                <div className='get-the-app-mobile mb-5 mt-4'>
                  <a href={downloadAppStoreUrl.url} target="_blank" rel="noopener noreferrer">
                    <img className="w-100" src={appStoreIcon} alt="Download App Store" />
                  </a>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>
    </section>
  )
}

export default GetTheApp;